export default __webpack_public_path__ + "static/media/sf9.38e36526.svg";